import clsx from 'clsx';
import { SEOArticle } from 'components/StructuredData/SEOArticle';
import { SEOHowTo } from 'components/StructuredData/SEOHowTo';
import { urlFor } from 'helpers/image';
import { useRouter } from 'next/router';
import { SanityArticleDataWithAuthor } from 'types/sanity';

import ContentWrapper from '../ContentWrapper';
import { Grid, GridItem } from '../Grid';
import { ArticleContent } from './ArticleContent';
import { ArticleMeta } from './ArticleMeta';
import { ArticleSidebar } from './ArticleSidebar';

export const ArticleLayout = ({ data }: { data: SanityArticleDataWithAuthor }) => {
  if (!data) return null;
  const router = useRouter();
  const hideTableOfContents = data.hideTableOfContents ?? false;
  const imageUrl = data.mainImage && urlFor(data.mainImage);
  const seoType = data.seoType;
  return (
    <>
      <ArticleMeta data={data} />
      {seoType === 'howTo' ? (
        <SEOHowTo
          title={data.title}
          seoTitle={data.seoTitle}
          seoMainEntityTitle={data.seoMainEntityTitle}
          author={data.author}
          datePublished={data.publishedAt}
          dateModified={data._updatedAt}
          imageUrl={imageUrl?.url()}
          howToTitle={data.seoHowToTitle}
          howToSteps={data.seoHowTo}
        />
      ) : (
        <SEOArticle
          title={data.seoTitle}
          language={router.locale}
          description={data.metaDescription}
          author={data.author}
          datePublished={data.publishedAt}
          dateModified={data._updatedAt}
          imageUrl={imageUrl?.url()}
        />
      )}

      <ContentWrapper
        className="px-0 lg:px-4 bg-white lg:bg-firi-light-grey lg:mt-10"
        constrained={hideTableOfContents}
      >
        <Grid>
          {!hideTableOfContents && (
            <GridItem className="hidden lg:block lg:col-span-3 top-20 self-start">
              <ArticleSidebar data={data} />
            </GridItem>
          )}
          <GridItem className={clsx(!hideTableOfContents && 'lg:col-span-9')}>
            <ArticleContent data={data} />
          </GridItem>
        </Grid>
      </ContentWrapper>
    </>
  );
};
